import { DataState } from "Models/Common/DataState";
import { Reducer } from "redux";
import { ActionTypes, ChecklistTemplateActions } from "./ChecklistTemplateActionTypes";
import { ChecklistTemplateState, IChecklistTemplateState } from "./ChecklistTemplateState";

export const initialState: IChecklistTemplateState = new ChecklistTemplateState();

const reducer: Reducer<IChecklistTemplateState> = (state: IChecklistTemplateState = initialState, action: ChecklistTemplateActions) => {
    switch (action.type) {
        case ActionTypes.CHECKLIST_SUGGESTIONS_RETRIEVED:
            return { ...state, suggestions: action.data };
        case ActionTypes.CHECKLIST_SUGGESTION_RETRIEVED:
            return { ...state, selectedSuggestion: action.data };
        case ActionTypes.CLEAR_CHECKLIST_TEMPLATES:
            return { ...state, checklistTemplates: [] };
        case ActionTypes.CHECKLIST_FILTER_UPDATED:
            return { ...state, currentFilter: action.filter, isLoading: true };
        case ActionTypes.CHECKLIST_PAGE_RETRIEVED:
            const checklistTemplates = state.checklistTemplates ? [...state.checklistTemplates] : [];
            const newTemplates = action.page.items.filter(newChecklistTemplate => checklistTemplates.find(t => t.id === newChecklistTemplate.id) === undefined);
            checklistTemplates.push(...newTemplates);
            return { ...state, checklistTemplates, totalChecklists: action.page.totalItems, isLoading: false };
        case ActionTypes.CHECKLIST_TEMPLATE_STATE_CHANGED:
            return { ...state, detailChecklistTemplateStates: { ...state.detailChecklistTemplateStates, [action.checklistTemplateId || -1]: action.newState } };
        case ActionTypes.CHECKLIST_TEMPLATE_RETRIEVED:
            return {
                ...state,
                detailChecklistTemplates: { ...state.detailChecklistTemplates, [action.checklistTemplate.id!]: action.checklistTemplate },
                detailChecklistTemplateStates: { ...state.detailChecklistTemplateStates, [action.checklistTemplate.id!]: DataState.Done }
            };
        case ActionTypes.SHOW_VALIDATION_ERRORS:
            const distinctValidationErrors = Array.from(new Set(action.validationErrors));
            return { ...state, detailChecklistTemplateValidationErrors: { ...state.detailChecklistTemplateValidationErrors, [action.checklistTemplateId || -1]: distinctValidationErrors } };
        case ActionTypes.CLEAR_VALIDATION_ERRORS:
            return { ...state, detailChecklistTemplateValidationErrors: { ...state.detailChecklistTemplateValidationErrors, [action.checklistTemplateId || -1]: [] } };
        case ActionTypes.CHECKLIST_TEMPLATE_SAVED:
            return {
                ...state,
                checklistTemplates: [],
                detailChecklistTemplates: { ...state.detailChecklistTemplates, [action.checklistTemplate.id!]: action.checklistTemplate },
                detailChecklistTemplateStates: { ...state.detailChecklistTemplates, [action.checklistTemplate.id!]: DataState.Done }
            };
        case ActionTypes.CHECKLIST_TEMPLATE_DELETED:
            // Remove the template from the overview page
            if (state.checklistTemplates) {
                const index = state.checklistTemplates.findIndex(x => x.id === action.checklistTemplateId);
                if (index >= 0) {
                    state.checklistTemplates.splice(index, 1);
                }
            }

            // Remove the template from the template detail storage
            if (state.detailChecklistTemplates && state.detailChecklistTemplates[action.checklistTemplateId]) {
                delete state.detailChecklistTemplates[action.checklistTemplateId];
            }

            return {
                ...state,
                detailChecklistTemplateStates: { ...state.detailChecklistTemplateStates, [action.checklistTemplateId]: DataState.Deleted }
            };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/ChecklistTemplates/ChecklistTemplateReducer.ts